import { gql } from "@apollo/client";
import { Inquiry } from "@App/types";

export interface CreateInquiryQuery {
  createInquiry: Inquiry;
}

export const CREATE_INQUIRY = gql`
    mutation CreateInquiry(
        $organization: ID!,
        $garage: ID!,
        $services: [ID]!,
        $service: ID,
        $firstName: String!,
        $lastName: String!,
        $email: String!,
        $phone: String!,
        $street: String,
        $city: String,
        $postcode: String,
        $addition: String,
        $numberPlate: String,
        $ecTypeApprovalNumber: String,
        $powerKw: Int,
        $mileage: Int,
        $message: String,
        $tos: Boolean!,
        $slot: ID,
        $marketing: Boolean,
        $adacMember: Boolean,
        $startDate: DateTimeTz!,
        $endDate: DateTimeTz!,
        $calendarId: ID!,
        $premiumServices: [ID],
        $brand: ID,
        $generation: ID,
        $motorization: ID,
        $body: ID,
        $gearbox: ID,
        $registrationDate: Date,
        $subRepairs: [String]
        $equipments: [String]
        $vin: String
        $keyNumber: String
        $additionalPremiumServiceInformation: [AdditionalPremiumServiceInformation]
        $mustUseAuthorizedGarage: Boolean
        $acceptedAdditionalCharges: Boolean
        $insuranceClaim: InsuranceClaimInput
        $isReturnCustomer: Boolean
        $garageProperties: [UUID!]
        $contractNumber: String
        $reviewOptIn: Boolean
    ) {
        createInquiry(
            input: {
                organization: $organization,
                garage: $garage,
                services: $services,
                service: $service,
                firstName: $firstName,
                lastName: $lastName,
                email: $email,
                phone: $phone,
                street: $street,
                city:  $city,
                postcode: $postcode,
                addition: $addition,
                numberPlate: $numberPlate,
                ecTypeApprovalNumber: $ecTypeApprovalNumber,
                powerKw: $powerKw,
                mileage: $mileage,
                message: $message,
                tos: $tos,
                slot: $slot,
                marketing: $marketing,
                adacMember: $adacMember,
                from: $startDate,
                to: $endDate,
                calendar: $calendarId,
                premiumServices: $premiumServices,
                brand: $brand,
                generation: $generation,
                motorization: $motorization,
                body: $body,
                gearbox: $gearbox,
                registrationDate: $registrationDate,
                sub_repairs: $subRepairs,
                equipments: $equipments,
                additionalPremiumServiceInformation: $additionalPremiumServiceInformation,
                mustUseAuthorizedGarage: $mustUseAuthorizedGarage,
                vin: $vin,
                keyNumber: $keyNumber
                acceptedAdditionalCharges: $acceptedAdditionalCharges
                insuranceClaim: $insuranceClaim
                isReturnCustomer: $isReturnCustomer
                garageProperties: $garageProperties
                contractNumber: $contractNumber
                reviewOptIn: $reviewOptIn
            }
        ) {
            id
            uuid
        }
    }
`;
